<template>
  <b-list-group
    style="margin-bottom: 3rem"
    class="h-100 wrapper__chat-box"
    :class="{ 'margin-custom-0__b': activeCustomClass }"
  >
    <b-list-group-item>
      <b class="text__chat-box-title">Chat Messages</b>
    </b-list-group-item>

    <b-list-group-item class="p-0 h-100 list-group__chat-box">
      <b-card
        ref="card__chat-box"
        class="card__chat-box chat-wrapper bg-transparent card-transparent h-100"
      >
        <b-card-text v-if="isLoading" class="text-center">
          <b-spinner v-if="isLoading" small />
        </b-card-text>

        <b-card-text
          v-for="(message, index) in messages"
          :key="`message-${index}`"
          ref="container__chat"
          class="chat-item"
        >
          <div class="chat__header d-flex justify-content-between">
            <h6 :ref="`text__fullname-${index}`" class="text__fullname">
              <b>{{ message.name }}</b>
            </h6>

            <span :ref="`text__message-time-${index}`" class="text__message-time">
              <small>{{ message.timestamp }}</small>
            </span>
          </div>

          <div
            :ref="`text__message-${index}`"
            v-safe-html="message.message"
            class="chat__body chat-box text__message bg-light text-dark text-pre-wrap"
          />
        </b-card-text>
      </b-card>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import axios from 'axios';
export default {
  name: 'BaseChatMessage',

  props: {
    link: {
      type: String,
      default: ''
    },

    activeCustomClass: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      messages: []
    };
  },

  watch: {
    link: {
      immediate: true,
      handler: 'loadMessages'
    }
  },

  methods: {
    async loadMessages() {
      if (!this.link) return;

      this.isLoading = true;

      const response = await axios.get(this.link, {
        responseType: 'blob'
      });

      const blob = new Blob([response.data]);

      const text = await blob.text();

      const messages = text
        .split(/\r?\n/)
        .map((message) => {
          return message && message.length ? message.split(/\t/) : [];
        })
        .filter((message) => message.length > 0)
        .map((message) => {
          return {
            timestamp: message[0],
            name: message[1].replace(':', ''),
            message: message[2]
          };
        });

      if (messages && messages.length) {
        this.messages = messages;
      }

      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper__chat-box {
  position: relative;
}

// .card__chat-box {
// max-height: 36vh;
// overflow: auto;
// }

.margin-custom-0__ {
  &b {
    margin-bottom: 0rem !important;
  }
}
</style>
